function cov_24jms4qfen() {
  var path = "/codebuild/output/src315236701/src/src/common/store/playCanvas.ts";
  var hash = "8975594799e4f2ddd61c06fd55080cb48fa63fd4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src315236701/src/src/common/store/playCanvas.ts",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 14,
          column: 16
        }
      },
      "1": {
        start: {
          line: 10,
          column: 46
        },
        end: {
          line: 14,
          column: 16
        }
      },
      "2": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 12,
          column: 20
        }
      },
      "3": {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 12,
          column: 20
        }
      },
      "4": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 48
        }
      },
      "5": {
        start: {
          line: 15,
          column: 34
        },
        end: {
          line: 237,
          column: 2
        }
      },
      "6": {
        start: {
          line: 16,
          column: 18
        },
        end: {
          line: 38,
          column: 5
        }
      },
      "7": {
        start: {
          line: 41,
          column: 34
        },
        end: {
          line: 41,
          column: 52
        }
      },
      "8": {
        start: {
          line: 42,
          column: 12
        },
        end: {
          line: 42,
          column: 62
        }
      },
      "9": {
        start: {
          line: 45,
          column: 34
        },
        end: {
          line: 45,
          column: 52
        }
      },
      "10": {
        start: {
          line: 46,
          column: 12
        },
        end: {
          line: 46,
          column: 64
        }
      },
      "11": {
        start: {
          line: 49,
          column: 12
        },
        end: {
          line: 50,
          column: 26
        }
      },
      "12": {
        start: {
          line: 50,
          column: 16
        },
        end: {
          line: 50,
          column: 26
        }
      },
      "13": {
        start: {
          line: 51,
          column: 12
        },
        end: {
          line: 57,
          column: 15
        }
      },
      "14": {
        start: {
          line: 52,
          column: 16
        },
        end: {
          line: 55,
          column: 17
        }
      },
      "15": {
        start: {
          line: 52,
          column: 29
        },
        end: {
          line: 52,
          column: 30
        }
      },
      "16": {
        start: {
          line: 53,
          column: 20
        },
        end: {
          line: 54,
          column: 45
        }
      },
      "17": {
        start: {
          line: 54,
          column: 24
        },
        end: {
          line: 54,
          column: 45
        }
      },
      "18": {
        start: {
          line: 56,
          column: 16
        },
        end: {
          line: 56,
          column: 25
        }
      },
      "19": {
        start: {
          line: 60,
          column: 12
        },
        end: {
          line: 61,
          column: 25
        }
      },
      "20": {
        start: {
          line: 61,
          column: 16
        },
        end: {
          line: 61,
          column: 25
        }
      },
      "21": {
        start: {
          line: 62,
          column: 12
        },
        end: {
          line: 62,
          column: 83
        }
      },
      "22": {
        start: {
          line: 65,
          column: 12
        },
        end: {
          line: 66,
          column: 33
        }
      },
      "23": {
        start: {
          line: 66,
          column: 16
        },
        end: {
          line: 66,
          column: 33
        }
      },
      "24": {
        start: {
          line: 67,
          column: 12
        },
        end: {
          line: 67,
          column: 88
        }
      },
      "25": {
        start: {
          line: 70,
          column: 12
        },
        end: {
          line: 71,
          column: 26
        }
      },
      "26": {
        start: {
          line: 71,
          column: 16
        },
        end: {
          line: 71,
          column: 26
        }
      },
      "27": {
        start: {
          line: 72,
          column: 12
        },
        end: {
          line: 72,
          column: 86
        }
      },
      "28": {
        start: {
          line: 72,
          column: 61
        },
        end: {
          line: 72,
          column: 84
        }
      },
      "29": {
        start: {
          line: 75,
          column: 34
        },
        end: {
          line: 75,
          column: 52
        }
      },
      "30": {
        start: {
          line: 76,
          column: 12
        },
        end: {
          line: 77,
          column: 28
        }
      },
      "31": {
        start: {
          line: 77,
          column: 16
        },
        end: {
          line: 77,
          column: 28
        }
      },
      "32": {
        start: {
          line: 78,
          column: 26
        },
        end: {
          line: 78,
          column: 89
        }
      },
      "33": {
        start: {
          line: 79,
          column: 12
        },
        end: {
          line: 79,
          column: 58
        }
      },
      "34": {
        start: {
          line: 82,
          column: 12
        },
        end: {
          line: 82,
          column: 102
        }
      },
      "35": {
        start: {
          line: 85,
          column: 12
        },
        end: {
          line: 85,
          column: 73
        }
      },
      "36": {
        start: {
          line: 88,
          column: 12
        },
        end: {
          line: 88,
          column: 53
        }
      },
      "37": {
        start: {
          line: 91,
          column: 12
        },
        end: {
          line: 91,
          column: 47
        }
      },
      "38": {
        start: {
          line: 94,
          column: 12
        },
        end: {
          line: 94,
          column: 43
        }
      },
      "39": {
        start: {
          line: 97,
          column: 12
        },
        end: {
          line: 97,
          column: 30
        }
      },
      "40": {
        start: {
          line: 100,
          column: 31
        },
        end: {
          line: 100,
          column: 56
        }
      },
      "41": {
        start: {
          line: 101,
          column: 34
        },
        end: {
          line: 101,
          column: 52
        }
      },
      "42": {
        start: {
          line: 102,
          column: 12
        },
        end: {
          line: 103,
          column: 25
        }
      },
      "43": {
        start: {
          line: 103,
          column: 16
        },
        end: {
          line: 103,
          column: 25
        }
      },
      "44": {
        start: {
          line: 104,
          column: 12
        },
        end: {
          line: 104,
          column: 80
        }
      },
      "45": {
        start: {
          line: 107,
          column: 26
        },
        end: {
          line: 107,
          column: 64
        }
      },
      "46": {
        start: {
          line: 108,
          column: 12
        },
        end: {
          line: 109,
          column: 29
        }
      },
      "47": {
        start: {
          line: 109,
          column: 16
        },
        end: {
          line: 109,
          column: 29
        }
      },
      "48": {
        start: {
          line: 110,
          column: 12
        },
        end: {
          line: 116,
          column: 15
        }
      },
      "49": {
        start: {
          line: 111,
          column: 16
        },
        end: {
          line: 112,
          column: 32
        }
      },
      "50": {
        start: {
          line: 112,
          column: 20
        },
        end: {
          line: 112,
          column: 32
        }
      },
      "51": {
        start: {
          line: 113,
          column: 16
        },
        end: {
          line: 114,
          column: 78
        }
      },
      "52": {
        start: {
          line: 114,
          column: 20
        },
        end: {
          line: 114,
          column: 78
        }
      },
      "53": {
        start: {
          line: 114,
          column: 50
        },
        end: {
          line: 114,
          column: 76
        }
      },
      "54": {
        start: {
          line: 115,
          column: 16
        },
        end: {
          line: 115,
          column: 29
        }
      },
      "55": {
        start: {
          line: 119,
          column: 26
        },
        end: {
          line: 119,
          column: 64
        }
      },
      "56": {
        start: {
          line: 120,
          column: 12
        },
        end: {
          line: 121,
          column: 29
        }
      },
      "57": {
        start: {
          line: 121,
          column: 16
        },
        end: {
          line: 121,
          column: 29
        }
      },
      "58": {
        start: {
          line: 122,
          column: 34
        },
        end: {
          line: 122,
          column: 51
        }
      },
      "59": {
        start: {
          line: 123,
          column: 12
        },
        end: {
          line: 124,
          column: 29
        }
      },
      "60": {
        start: {
          line: 124,
          column: 16
        },
        end: {
          line: 124,
          column: 29
        }
      },
      "61": {
        start: {
          line: 125,
          column: 12
        },
        end: {
          line: 131,
          column: 15
        }
      },
      "62": {
        start: {
          line: 126,
          column: 16
        },
        end: {
          line: 127,
          column: 32
        }
      },
      "63": {
        start: {
          line: 127,
          column: 20
        },
        end: {
          line: 127,
          column: 32
        }
      },
      "64": {
        start: {
          line: 128,
          column: 16
        },
        end: {
          line: 129,
          column: 104
        }
      },
      "65": {
        start: {
          line: 129,
          column: 20
        },
        end: {
          line: 129,
          column: 104
        }
      },
      "66": {
        start: {
          line: 129,
          column: 50
        },
        end: {
          line: 129,
          column: 102
        }
      },
      "67": {
        start: {
          line: 130,
          column: 16
        },
        end: {
          line: 130,
          column: 29
        }
      },
      "68": {
        start: {
          line: 139,
          column: 26
        },
        end: {
          line: 139,
          column: 36
        }
      },
      "69": {
        start: {
          line: 140,
          column: 12
        },
        end: {
          line: 140,
          column: 81
        }
      },
      "70": {
        start: {
          line: 141,
          column: 27
        },
        end: {
          line: 143,
          column: 14
        }
      },
      "71": {
        start: {
          line: 144,
          column: 12
        },
        end: {
          line: 144,
          column: 45
        }
      },
      "72": {
        start: {
          line: 147,
          column: 12
        },
        end: {
          line: 147,
          column: 38
        }
      },
      "73": {
        start: {
          line: 153,
          column: 29
        },
        end: {
          line: 156,
          column: 14
        }
      },
      "74": {
        start: {
          line: 157,
          column: 12
        },
        end: {
          line: 159,
          column: 13
        }
      },
      "75": {
        start: {
          line: 158,
          column: 16
        },
        end: {
          line: 158,
          column: 73
        }
      },
      "76": {
        start: {
          line: 160,
          column: 12
        },
        end: {
          line: 160,
          column: 28
        }
      },
      "77": {
        start: {
          line: 163,
          column: 30
        },
        end: {
          line: 163,
          column: 89
        }
      },
      "78": {
        start: {
          line: 164,
          column: 32
        },
        end: {
          line: 164,
          column: 48
        }
      },
      "79": {
        start: {
          line: 165,
          column: 34
        },
        end: {
          line: 165,
          column: 52
        }
      },
      "80": {
        start: {
          line: 166,
          column: 30
        },
        end: {
          line: 166,
          column: 60
        }
      },
      "81": {
        start: {
          line: 167,
          column: 34
        },
        end: {
          line: 167,
          column: 59
        }
      },
      "82": {
        start: {
          line: 168,
          column: 12
        },
        end: {
          line: 189,
          column: 13
        }
      },
      "83": {
        start: {
          line: 169,
          column: 16
        },
        end: {
          line: 185,
          column: 23
        }
      },
      "84": {
        start: {
          line: 175,
          column: 36
        },
        end: {
          line: 175,
          column: 59
        }
      },
      "85": {
        start: {
          line: 176,
          column: 20
        },
        end: {
          line: 177,
          column: 36
        }
      },
      "86": {
        start: {
          line: 177,
          column: 24
        },
        end: {
          line: 177,
          column: 36
        }
      },
      "87": {
        start: {
          line: 179,
          column: 39
        },
        end: {
          line: 179,
          column: 79
        }
      },
      "88": {
        start: {
          line: 180,
          column: 20
        },
        end: {
          line: 181,
          column: 36
        }
      },
      "89": {
        start: {
          line: 181,
          column: 24
        },
        end: {
          line: 181,
          column: 36
        }
      },
      "90": {
        start: {
          line: 182,
          column: 20
        },
        end: {
          line: 183,
          column: 36
        }
      },
      "91": {
        start: {
          line: 183,
          column: 24
        },
        end: {
          line: 183,
          column: 36
        }
      },
      "92": {
        start: {
          line: 184,
          column: 20
        },
        end: {
          line: 184,
          column: 43
        }
      },
      "93": {
        start: {
          line: 188,
          column: 16
        },
        end: {
          line: 188,
          column: 51
        }
      },
      "94": {
        start: {
          line: 190,
          column: 12
        },
        end: {
          line: 190,
          column: 55
        }
      },
      "95": {
        start: {
          line: 191,
          column: 34
        },
        end: {
          line: 191,
          column: 59
        }
      },
      "96": {
        start: {
          line: 192,
          column: 12
        },
        end: {
          line: 193,
          column: 80
        }
      },
      "97": {
        start: {
          line: 193,
          column: 16
        },
        end: {
          line: 193,
          column: 80
        }
      },
      "98": {
        start: {
          line: 194,
          column: 12
        },
        end: {
          line: 194,
          column: 47
        }
      },
      "99": {
        start: {
          line: 197,
          column: 34
        },
        end: {
          line: 197,
          column: 52
        }
      },
      "100": {
        start: {
          line: 198,
          column: 29
        },
        end: {
          line: 198,
          column: 86
        }
      },
      "101": {
        start: {
          line: 198,
          column: 65
        },
        end: {
          line: 198,
          column: 85
        }
      },
      "102": {
        start: {
          line: 199,
          column: 12
        },
        end: {
          line: 202,
          column: 51
        }
      },
      "103": {
        start: {
          line: 200,
          column: 16
        },
        end: {
          line: 200,
          column: 77
        }
      },
      "104": {
        start: {
          line: 202,
          column: 16
        },
        end: {
          line: 202,
          column: 51
        }
      },
      "105": {
        start: {
          line: 203,
          column: 12
        },
        end: {
          line: 203,
          column: 55
        }
      },
      "106": {
        start: {
          line: 209,
          column: 34
        },
        end: {
          line: 209,
          column: 52
        }
      },
      "107": {
        start: {
          line: 210,
          column: 29
        },
        end: {
          line: 213,
          column: 31
        }
      },
      "108": {
        start: {
          line: 214,
          column: 12
        },
        end: {
          line: 215,
          column: 28
        }
      },
      "109": {
        start: {
          line: 215,
          column: 16
        },
        end: {
          line: 215,
          column: 28
        }
      },
      "110": {
        start: {
          line: 216,
          column: 12
        },
        end: {
          line: 218,
          column: 13
        }
      },
      "111": {
        start: {
          line: 217,
          column: 16
        },
        end: {
          line: 217,
          column: 64
        }
      },
      "112": {
        start: {
          line: 219,
          column: 12
        },
        end: {
          line: 219,
          column: 43
        }
      },
      "113": {
        start: {
          line: 220,
          column: 12
        },
        end: {
          line: 220,
          column: 35
        }
      },
      "114": {
        start: {
          line: 227,
          column: 33
        },
        end: {
          line: 227,
          column: 50
        }
      },
      "115": {
        start: {
          line: 228,
          column: 12
        },
        end: {
          line: 228,
          column: 51
        }
      },
      "116": {
        start: {
          line: 229,
          column: 12
        },
        end: {
          line: 230,
          column: 40
        }
      },
      "117": {
        start: {
          line: 230,
          column: 16
        },
        end: {
          line: 230,
          column: 40
        }
      },
      "118": {
        start: {
          line: 231,
          column: 12
        },
        end: {
          line: 234,
          column: 19
        }
      },
      "119": {
        start: {
          line: 232,
          column: 16
        },
        end: {
          line: 232,
          column: 79
        }
      },
      "120": {
        start: {
          line: 233,
          column: 16
        },
        end: {
          line: 233,
          column: 38
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 30
          },
          end: {
            line: 10,
            column: 31
          }
        },
        loc: {
          start: {
            line: 10,
            column: 46
          },
          end: {
            line: 14,
            column: 16
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 10,
            column: 59
          },
          end: {
            line: 10,
            column: 60
          }
        },
        loc: {
          start: {
            line: 10,
            column: 75
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 10
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 16,
            column: 11
          },
          end: {
            line: 16,
            column: 12
          }
        },
        loc: {
          start: {
            line: 16,
            column: 18
          },
          end: {
            line: 38,
            column: 5
          }
        },
        line: 16
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 40,
            column: 16
          },
          end: {
            line: 40,
            column: 17
          }
        },
        loc: {
          start: {
            line: 40,
            column: 22
          },
          end: {
            line: 43,
            column: 9
          }
        },
        line: 40
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 44,
            column: 18
          },
          end: {
            line: 44,
            column: 19
          }
        },
        loc: {
          start: {
            line: 44,
            column: 24
          },
          end: {
            line: 47,
            column: 9
          }
        },
        line: 44
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 48,
            column: 32
          },
          end: {
            line: 48,
            column: 33
          }
        },
        loc: {
          start: {
            line: 48,
            column: 43
          },
          end: {
            line: 58,
            column: 9
          }
        },
        line: 48
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 51,
            column: 44
          },
          end: {
            line: 51,
            column: 45
          }
        },
        loc: {
          start: {
            line: 51,
            column: 54
          },
          end: {
            line: 57,
            column: 13
          }
        },
        line: 51
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 59,
            column: 9
          }
        },
        loc: {
          start: {
            line: 59,
            column: 25
          },
          end: {
            line: 63,
            column: 9
          }
        },
        line: 59
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 64,
            column: 8
          },
          end: {
            line: 64,
            column: 9
          }
        },
        loc: {
          start: {
            line: 64,
            column: 31
          },
          end: {
            line: 68,
            column: 9
          }
        },
        line: 64
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        },
        loc: {
          start: {
            line: 69,
            column: 37
          },
          end: {
            line: 73,
            column: 9
          }
        },
        line: 69
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 72,
            column: 51
          },
          end: {
            line: 72,
            column: 52
          }
        },
        loc: {
          start: {
            line: 72,
            column: 61
          },
          end: {
            line: 72,
            column: 84
          }
        },
        line: 72
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 9
          }
        },
        loc: {
          start: {
            line: 74,
            column: 34
          },
          end: {
            line: 80,
            column: 9
          }
        },
        line: 74
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 81,
            column: 9
          }
        },
        loc: {
          start: {
            line: 81,
            column: 25
          },
          end: {
            line: 83,
            column: 9
          }
        },
        line: 81
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 84,
            column: 9
          }
        },
        loc: {
          start: {
            line: 84,
            column: 29
          },
          end: {
            line: 86,
            column: 9
          }
        },
        line: 84
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 87,
            column: 8
          },
          end: {
            line: 87,
            column: 9
          }
        },
        loc: {
          start: {
            line: 87,
            column: 24
          },
          end: {
            line: 89,
            column: 9
          }
        },
        line: 87
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 90,
            column: 8
          },
          end: {
            line: 90,
            column: 9
          }
        },
        loc: {
          start: {
            line: 90,
            column: 21
          },
          end: {
            line: 92,
            column: 9
          }
        },
        line: 90
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 93,
            column: 8
          },
          end: {
            line: 93,
            column: 9
          }
        },
        loc: {
          start: {
            line: 93,
            column: 32
          },
          end: {
            line: 95,
            column: 9
          }
        },
        line: 93
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 96,
            column: 8
          },
          end: {
            line: 96,
            column: 9
          }
        },
        loc: {
          start: {
            line: 96,
            column: 21
          },
          end: {
            line: 98,
            column: 9
          }
        },
        line: 96
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 99,
            column: 8
          },
          end: {
            line: 99,
            column: 9
          }
        },
        loc: {
          start: {
            line: 99,
            column: 32
          },
          end: {
            line: 105,
            column: 9
          }
        },
        line: 99
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 106,
            column: 8
          },
          end: {
            line: 106,
            column: 9
          }
        },
        loc: {
          start: {
            line: 106,
            column: 19
          },
          end: {
            line: 117,
            column: 9
          }
        },
        line: 106
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 110,
            column: 39
          },
          end: {
            line: 110,
            column: 40
          }
        },
        loc: {
          start: {
            line: 110,
            column: 46
          },
          end: {
            line: 116,
            column: 13
          }
        },
        line: 110
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 114,
            column: 43
          },
          end: {
            line: 114,
            column: 44
          }
        },
        loc: {
          start: {
            line: 114,
            column: 50
          },
          end: {
            line: 114,
            column: 76
          }
        },
        line: 114
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 118,
            column: 8
          },
          end: {
            line: 118,
            column: 9
          }
        },
        loc: {
          start: {
            line: 118,
            column: 22
          },
          end: {
            line: 132,
            column: 9
          }
        },
        line: 118
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 125,
            column: 39
          },
          end: {
            line: 125,
            column: 40
          }
        },
        loc: {
          start: {
            line: 125,
            column: 46
          },
          end: {
            line: 131,
            column: 13
          }
        },
        line: 125
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 129,
            column: 43
          },
          end: {
            line: 129,
            column: 44
          }
        },
        loc: {
          start: {
            line: 129,
            column: 50
          },
          end: {
            line: 129,
            column: 102
          }
        },
        line: 129
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 138,
            column: 8
          },
          end: {
            line: 138,
            column: 9
          }
        },
        loc: {
          start: {
            line: 138,
            column: 34
          },
          end: {
            line: 145,
            column: 9
          }
        },
        line: 138
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 146,
            column: 8
          },
          end: {
            line: 146,
            column: 9
          }
        },
        loc: {
          start: {
            line: 146,
            column: 31
          },
          end: {
            line: 148,
            column: 9
          }
        },
        line: 146
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 152,
            column: 8
          },
          end: {
            line: 152,
            column: 9
          }
        },
        loc: {
          start: {
            line: 152,
            column: 50
          },
          end: {
            line: 161,
            column: 9
          }
        },
        line: 152
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 162,
            column: 8
          },
          end: {
            line: 162,
            column: 9
          }
        },
        loc: {
          start: {
            line: 162,
            column: 38
          },
          end: {
            line: 195,
            column: 9
          }
        },
        line: 162
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 172,
            column: 25
          },
          end: {
            line: 172,
            column: 26
          }
        },
        loc: {
          start: {
            line: 172,
            column: 41
          },
          end: {
            line: 185,
            column: 17
          }
        },
        line: 172
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 196,
            column: 8
          },
          end: {
            line: 196,
            column: 9
          }
        },
        loc: {
          start: {
            line: 196,
            column: 40
          },
          end: {
            line: 204,
            column: 9
          }
        },
        line: 196
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 198,
            column: 55
          },
          end: {
            line: 198,
            column: 56
          }
        },
        loc: {
          start: {
            line: 198,
            column: 65
          },
          end: {
            line: 198,
            column: 85
          }
        },
        line: 198
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 208,
            column: 8
          },
          end: {
            line: 208,
            column: 9
          }
        },
        loc: {
          start: {
            line: 208,
            column: 41
          },
          end: {
            line: 221,
            column: 9
          }
        },
        line: 208
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 213,
            column: 21
          },
          end: {
            line: 213,
            column: 22
          }
        },
        loc: {
          start: {
            line: 213,
            column: 27
          },
          end: {
            line: 213,
            column: 30
          }
        },
        line: 213
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 226,
            column: 8
          },
          end: {
            line: 226,
            column: 9
          }
        },
        loc: {
          start: {
            line: 226,
            column: 32
          },
          end: {
            line: 235,
            column: 9
          }
        },
        line: 226
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 231,
            column: 35
          },
          end: {
            line: 231,
            column: 36
          }
        },
        loc: {
          start: {
            line: 231,
            column: 41
          },
          end: {
            line: 234,
            column: 13
          }
        },
        line: 231
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 10,
            column: 31
          },
          end: {
            line: 10,
            column: 41
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 10,
            column: 39
          },
          end: {
            line: 10,
            column: 41
          }
        }],
        line: 10
      },
      "1": {
        loc: {
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 12,
            column: 20
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 12,
            column: 20
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 11
      },
      "2": {
        loc: {
          start: {
            line: 42,
            column: 19
          },
          end: {
            line: 42,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 42,
            column: 19
          },
          end: {
            line: 42,
            column: 55
          }
        }, {
          start: {
            line: 42,
            column: 59
          },
          end: {
            line: 42,
            column: 61
          }
        }],
        line: 42
      },
      "3": {
        loc: {
          start: {
            line: 46,
            column: 19
          },
          end: {
            line: 46,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 19
          },
          end: {
            line: 46,
            column: 57
          }
        }, {
          start: {
            line: 46,
            column: 61
          },
          end: {
            line: 46,
            column: 63
          }
        }],
        line: 46
      },
      "4": {
        loc: {
          start: {
            line: 49,
            column: 12
          },
          end: {
            line: 50,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 49,
            column: 12
          },
          end: {
            line: 50,
            column: 26
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 49
      },
      "5": {
        loc: {
          start: {
            line: 53,
            column: 20
          },
          end: {
            line: 54,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 20
          },
          end: {
            line: 54,
            column: 45
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 53
      },
      "6": {
        loc: {
          start: {
            line: 60,
            column: 12
          },
          end: {
            line: 61,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 12
          },
          end: {
            line: 61,
            column: 25
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 60
      },
      "7": {
        loc: {
          start: {
            line: 60,
            column: 16
          },
          end: {
            line: 60,
            column: 153
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 60,
            column: 16
          },
          end: {
            line: 60,
            column: 55
          }
        }, {
          start: {
            line: 60,
            column: 59
          },
          end: {
            line: 60,
            column: 98
          }
        }, {
          start: {
            line: 60,
            column: 102
          },
          end: {
            line: 60,
            column: 153
          }
        }],
        line: 60
      },
      "8": {
        loc: {
          start: {
            line: 65,
            column: 12
          },
          end: {
            line: 66,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 12
          },
          end: {
            line: 66,
            column: 33
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 65
      },
      "9": {
        loc: {
          start: {
            line: 65,
            column: 16
          },
          end: {
            line: 65,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 65,
            column: 16
          },
          end: {
            line: 65,
            column: 44
          }
        }, {
          start: {
            line: 65,
            column: 48
          },
          end: {
            line: 65,
            column: 88
          }
        }],
        line: 65
      },
      "10": {
        loc: {
          start: {
            line: 70,
            column: 12
          },
          end: {
            line: 71,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 12
          },
          end: {
            line: 71,
            column: 26
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 70
      },
      "11": {
        loc: {
          start: {
            line: 76,
            column: 12
          },
          end: {
            line: 77,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 12
          },
          end: {
            line: 77,
            column: 28
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 76
      },
      "12": {
        loc: {
          start: {
            line: 76,
            column: 16
          },
          end: {
            line: 76,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 76,
            column: 16
          },
          end: {
            line: 76,
            column: 60
          }
        }, {
          start: {
            line: 76,
            column: 64
          },
          end: {
            line: 76,
            column: 92
          }
        }],
        line: 76
      },
      "13": {
        loc: {
          start: {
            line: 79,
            column: 19
          },
          end: {
            line: 79,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 79,
            column: 42
          },
          end: {
            line: 79,
            column: 47
          }
        }, {
          start: {
            line: 79,
            column: 50
          },
          end: {
            line: 79,
            column: 57
          }
        }],
        line: 79
      },
      "14": {
        loc: {
          start: {
            line: 82,
            column: 19
          },
          end: {
            line: 82,
            column: 101
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 82,
            column: 19
          },
          end: {
            line: 82,
            column: 44
          }
        }, {
          start: {
            line: 82,
            column: 48
          },
          end: {
            line: 82,
            column: 77
          }
        }, {
          start: {
            line: 82,
            column: 81
          },
          end: {
            line: 82,
            column: 101
          }
        }],
        line: 82
      },
      "15": {
        loc: {
          start: {
            line: 85,
            column: 19
          },
          end: {
            line: 85,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 19
          },
          end: {
            line: 85,
            column: 48
          }
        }, {
          start: {
            line: 85,
            column: 52
          },
          end: {
            line: 85,
            column: 72
          }
        }],
        line: 85
      },
      "16": {
        loc: {
          start: {
            line: 88,
            column: 19
          },
          end: {
            line: 88,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 88,
            column: 19
          },
          end: {
            line: 88,
            column: 43
          }
        }, {
          start: {
            line: 88,
            column: 47
          },
          end: {
            line: 88,
            column: 52
          }
        }],
        line: 88
      },
      "17": {
        loc: {
          start: {
            line: 91,
            column: 19
          },
          end: {
            line: 91,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 19
          },
          end: {
            line: 91,
            column: 40
          }
        }, {
          start: {
            line: 91,
            column: 44
          },
          end: {
            line: 91,
            column: 46
          }
        }],
        line: 91
      },
      "18": {
        loc: {
          start: {
            line: 102,
            column: 12
          },
          end: {
            line: 103,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 12
          },
          end: {
            line: 103,
            column: 25
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 102
      },
      "19": {
        loc: {
          start: {
            line: 102,
            column: 16
          },
          end: {
            line: 102,
            column: 106
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 102,
            column: 16
          },
          end: {
            line: 102,
            column: 53
          }
        }, {
          start: {
            line: 102,
            column: 57
          },
          end: {
            line: 102,
            column: 106
          }
        }],
        line: 102
      },
      "20": {
        loc: {
          start: {
            line: 108,
            column: 12
          },
          end: {
            line: 109,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 108,
            column: 12
          },
          end: {
            line: 109,
            column: 29
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 108
      },
      "21": {
        loc: {
          start: {
            line: 111,
            column: 16
          },
          end: {
            line: 112,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 111,
            column: 16
          },
          end: {
            line: 112,
            column: 32
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 111
      },
      "22": {
        loc: {
          start: {
            line: 113,
            column: 16
          },
          end: {
            line: 114,
            column: 78
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 16
          },
          end: {
            line: 114,
            column: 78
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 113
      },
      "23": {
        loc: {
          start: {
            line: 120,
            column: 12
          },
          end: {
            line: 121,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 120,
            column: 12
          },
          end: {
            line: 121,
            column: 29
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 120
      },
      "24": {
        loc: {
          start: {
            line: 123,
            column: 12
          },
          end: {
            line: 124,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 123,
            column: 12
          },
          end: {
            line: 124,
            column: 29
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 123
      },
      "25": {
        loc: {
          start: {
            line: 126,
            column: 16
          },
          end: {
            line: 127,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 126,
            column: 16
          },
          end: {
            line: 127,
            column: 32
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 126
      },
      "26": {
        loc: {
          start: {
            line: 126,
            column: 20
          },
          end: {
            line: 126,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 126,
            column: 20
          },
          end: {
            line: 126,
            column: 46
          }
        }, {
          start: {
            line: 126,
            column: 50
          },
          end: {
            line: 126,
            column: 72
          }
        }],
        line: 126
      },
      "27": {
        loc: {
          start: {
            line: 128,
            column: 16
          },
          end: {
            line: 129,
            column: 104
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 128,
            column: 16
          },
          end: {
            line: 129,
            column: 104
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 128
      },
      "28": {
        loc: {
          start: {
            line: 129,
            column: 50
          },
          end: {
            line: 129,
            column: 102
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 129,
            column: 50
          },
          end: {
            line: 129,
            column: 76
          }
        }, {
          start: {
            line: 129,
            column: 80
          },
          end: {
            line: 129,
            column: 102
          }
        }],
        line: 129
      },
      "29": {
        loc: {
          start: {
            line: 140,
            column: 45
          },
          end: {
            line: 140,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 140,
            column: 45
          },
          end: {
            line: 140,
            column: 73
          }
        }, {
          start: {
            line: 140,
            column: 77
          },
          end: {
            line: 140,
            column: 78
          }
        }],
        line: 140
      },
      "30": {
        loc: {
          start: {
            line: 157,
            column: 12
          },
          end: {
            line: 159,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 157,
            column: 12
          },
          end: {
            line: 159,
            column: 13
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 157
      },
      "31": {
        loc: {
          start: {
            line: 163,
            column: 30
          },
          end: {
            line: 163,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 163,
            column: 60
          },
          end: {
            line: 163,
            column: 72
          }
        }, {
          start: {
            line: 163,
            column: 75
          },
          end: {
            line: 163,
            column: 89
          }
        }],
        line: 163
      },
      "32": {
        loc: {
          start: {
            line: 168,
            column: 12
          },
          end: {
            line: 189,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 168,
            column: 12
          },
          end: {
            line: 189,
            column: 13
          }
        }, {
          start: {
            line: 187,
            column: 17
          },
          end: {
            line: 189,
            column: 13
          }
        }],
        line: 168
      },
      "33": {
        loc: {
          start: {
            line: 176,
            column: 20
          },
          end: {
            line: 177,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 176,
            column: 20
          },
          end: {
            line: 177,
            column: 36
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 176
      },
      "34": {
        loc: {
          start: {
            line: 180,
            column: 20
          },
          end: {
            line: 181,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 180,
            column: 20
          },
          end: {
            line: 181,
            column: 36
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 180
      },
      "35": {
        loc: {
          start: {
            line: 180,
            column: 24
          },
          end: {
            line: 180,
            column: 107
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 180,
            column: 24
          },
          end: {
            line: 180,
            column: 63
          }
        }, {
          start: {
            line: 180,
            column: 67
          },
          end: {
            line: 180,
            column: 107
          }
        }],
        line: 180
      },
      "36": {
        loc: {
          start: {
            line: 182,
            column: 20
          },
          end: {
            line: 183,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 182,
            column: 20
          },
          end: {
            line: 183,
            column: 36
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 182
      },
      "37": {
        loc: {
          start: {
            line: 192,
            column: 12
          },
          end: {
            line: 193,
            column: 80
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 192,
            column: 12
          },
          end: {
            line: 193,
            column: 80
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 192
      },
      "38": {
        loc: {
          start: {
            line: 199,
            column: 12
          },
          end: {
            line: 202,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 199,
            column: 12
          },
          end: {
            line: 202,
            column: 51
          }
        }, {
          start: {
            line: 202,
            column: 16
          },
          end: {
            line: 202,
            column: 51
          }
        }],
        line: 199
      },
      "39": {
        loc: {
          start: {
            line: 214,
            column: 12
          },
          end: {
            line: 215,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 214,
            column: 12
          },
          end: {
            line: 215,
            column: 28
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 214
      },
      "40": {
        loc: {
          start: {
            line: 216,
            column: 12
          },
          end: {
            line: 218,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 216,
            column: 12
          },
          end: {
            line: 218,
            column: 13
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 216
      },
      "41": {
        loc: {
          start: {
            line: 229,
            column: 12
          },
          end: {
            line: 230,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 229,
            column: 12
          },
          end: {
            line: 230,
            column: 40
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 229
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/codebuild/output/src315236701/src/src/common/store/playCanvas.ts",
      sourceRoot: "",
      sources: ["/codebuild/output/src315236701/src/node_modules/vue-cli-plugin-quasar/lib/loader.js.transform-quasar-imports.js!/codebuild/output/src315236701/src/src/common/store/playCanvas.ts"],
      names: [],
      mappings: "AAAA,OAAO,EAAE,WAAW,EAAE,MAAM,OAAO,CAAC;AACpC,OAAO,EAAE,QAAQ,EAAE,MAAM,wBAAwB,CAAC;AAClD,OAAO,EAAE,WAAW,EAAE,MAAM,gBAAgB,CAAC;AAC7C,OAAO,EAAE,GAAG,EAAE,aAAa,EAAE,MAAM,gBAAgB,CAAC;AACpD,OAAO,EAAE,SAAS,EAAE,MAAM,yBAAyB,CAAC;AAEpD,OAAO,EAAE,gBAAgB,EAAE,MAAM,YAAY,CAAC;AAC9C,OAAO,EAAE,cAAc,EAAE,MAAM,UAAU,CAAC;AAC1C,OAAO,EAAE,eAAe,EAAE,MAAM,WAAW,CAAC;AAE5C,IAAI,SAAwC,CAAC;AAE7C,MAAM,CAAC,MAAM,cAAc,GAAG,CAAC,KAAK,GAAG,EAAE,EAAE,EAAE,CAAC,KAAK,CAAC,MAAM,CAAC,CAAC,IAAI,EAAE,IAAI,EAAE,EAAE;IACxE,IAAI,CAAC,IAAI,CAAC,QAAQ;QAAE,OAAO,IAAI,CAAC;IAChC,OAAO,IAAI,GAAG,cAAc,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAC;AAC9C,CAAC,EAAE,KAAK,CAAC,MAAM,CAAC,CAAC;AAEjB,MAAM,CAAC,MAAM,kBAAkB,GAAG,WAAW,CAAC,YAAY,EAAE;IAC1D,KAAK,EAAE,GAAG,EAAE,CAAC,CAAC;QACZ,YAAY,EAAE,EAAE;QAChB,KAAK,EAAE;YACL,MAAM,EAAE,EAAE;YACV,MAAM,EAAE,EAAE;YACV,KAAK,EAAE,EAAE;YACT,KAAK,EAAE,EAAE;YACT,MAAM,EAAE,EAAE,IAAI,EAAE,CAAC,EAAE;YACnB,MAAM,EAAE,EAAE,QAAQ,EAAE,CAAC,EAAE,WAAW,EAAE,CAAC,EAAE;SACxC;QACD,UAAU,EAAE,EAAE;QACd,KAAK,EAAE,KAAK;QACZ,kBAAkB,EAAE,WAAW,CAAC,QAAQ;QACxC,WAAW,EAAE,KAAK;QAClB,WAAW,EAAE,EAAE;QACf,iBAAiB,EAAE,EAAE;QACrB,KAAK,EAAE,IAAI;QACX,eAAe,EAAE,IAAI;QACrB,aAAa,EAAE,EAAc;QAC7B,mBAAmB,EAAE,IAAI;QACzB,aAAa,EAAE,EAAE;QACjB,SAAS,EAAE,EAAE;KACd,CAAC;IAEF,OAAO,EAAE;QACP,MAAM,EAAE,GAAG,EAAE;YACX,MAAM,aAAa,GAAG,gBAAgB,EAAE,CAAC;YACzC,OAAO,aAAa,CAAC,eAAe,CAAC,MAAM,IAAI,EAAE,CAAC;QACpD,CAAC;QAED,QAAQ,EAAE,GAAkB,EAAE;YAC5B,MAAM,aAAa,GAAG,gBAAgB,EAAE,CAAC;YACzC,OAAO,aAAa,CAAC,eAAe,CAAC,QAAQ,IAAI,EAAmB,CAAC;QACvE,CAAC;QAED,sBAAsB,EAAE,CAAC,KAAK,EAAY,EAAE;YAC1C,IAAI,CAAC,KAAK,CAAC,aAAa;gBAAE,OAAO,EAAE,CAAC;YACpC,OAAO,KAAK,CAAC,aAAa,CAAC,IAAI,CAAC,CAAC,CAAC,EAAE,CAAC,EAAE,EAAE;gBACvC,KAAK,IAAI,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,CAAC,CAAC,MAAM,EAAE,CAAC,IAAI,CAAC,EAAE;oBACpC,IAAI,CAAC,CAAC,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC;wBAAE,OAAO,CAAC,CAAC,CAAC,CAAC,CAAC,GAAG,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC;iBACzC;gBACD,OAAO,CAAC,CAAC;YACX,CAAC,CAAC,CAAC;QACL,CAAC;QAED,cAAc;YACZ,IAAI,IAAI,CAAC,oBAAoB,KAAK,SAAS,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,IAAI,CAAC,oBAAoB,CAAC,IAAI,IAAI,CAAC,MAAM,CAAC,IAAI,CAAC,oBAAoB,CAAC,CAAC,MAAM,KAAK,CAAC;gBAAE,OAAO,CAAC,CAAC;YACxJ,OAAO,cAAc,CAAC,IAAI,CAAC,MAAM,CAAC,IAAI,CAAC,oBAAoB,CAAC,CAAC,QAAQ,CAAC,CAAC;QACzE,CAAC;QAED,oBAAoB;YAClB,IAAI,CAAC,IAAI,CAAC,sBAAsB,IAAI,IAAI,CAAC,sBAAsB,CAAC,MAAM,KAAK,CAAC;gBAAE,OAAO,SAAS,CAAC;YAC/F,OAAO,QAAQ,CAAC,IAAI,CAAC,sBAAsB,CAAC,CAAC,CAAC,CAAC,KAAK,CAAC,WAAW,CAAC,EAAE,CAAC,CAAC,CAAC,EAAE,EAAE,CAAC,CAAC;QAC9E,CAAC;QAED,0BAA0B;YACxB,IAAI,CAAC,IAAI,CAAC,sBAAsB;gBAAE,OAAO,EAAE,CAAC;YAC5C,OAAO,IAAI,CAAC,sBAAsB,CAAC,GAAG,CAAC,CAAC,IAAI,EAAE,EAAE,CAAC,IAAI,CAAC,KAAK,CAAC,WAAW,CAAC,CAAC,CAAC;QAC5E,CAAC;QAED,uBAAuB;YACrB,MAAM,aAAa,GAAG,gBAAgB,EAAE,CAAC;YACzC,IAAI,aAAa,CAAC,aAAa,CAAC,eAAe,CAAC,IAAI,CAAC,IAAI,CAAC,sBAAsB;gBAAE,OAAO,CAAC,EAAY,CAAC,CAAC;YACxG,MAAM,KAAK,GAAG,GAAG,CAAC,aAAa,CAAC,eAAe,EAAE,IAAI,CAAC,sBAAsB,CAAC,CAAC;YAC9E,OAAO,KAAK,CAAC,OAAO,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,KAAK,CAAC,CAAC;QAChD,CAAC;QAED,cAAc;YACZ,OAAO,IAAI,CAAC,QAAQ,CAAC,WAA0B,IAAI,IAAI,CAAC,QAAQ,CAAC,eAA8B,IAAI,WAAW,CAAC,QAAQ,CAAC;QAC1H,CAAC;QAED,kBAAkB;YAChB,OAAO,IAAI,CAAC,QAAQ,CAAC,eAA8B,IAAI,WAAW,CAAC,QAAQ,CAAC;QAC9E,CAAC;QAED,aAAa;YACX,OAAO,IAAI,CAAC,QAAQ,CAAC,UAAqB,IAAI,KAAK,CAAC;QACtD,CAAC;QAED,UAAU;YACR,OAAO,IAAI,CAAC,QAAQ,CAAC,OAAiC,IAAI,EAA4B,CAAC;QACzF,CAAC;QAED,qBAAqB;YACnB,OAAO,IAAI,CAAC,kBAAiC,CAAC;QAChD,CAAC;QAED,UAAU;YACR,OAAO,IAAI,CAAC,KAAK,CAAC;QACpB,CAAC;QAED,qBAAqB;YACnB,MAAM,UAAU,GAAG,IAAI,CAAC,oBAAoB,CAAC;YAC7C,MAAM,aAAa,GAAG,gBAAgB,EAAE,CAAC;YACzC,IAAI,CAAC,aAAa,CAAC,eAAe,CAAC,MAAM,IAAI,CAAC,aAAa,CAAC,eAAe,CAAC,MAAM,CAAC,UAAU,CAAC;gBAAE,OAAO,CAAC,CAAC;YACzG,OAAO,aAAa,CAAC,eAAe,CAAC,MAAM,CAAC,UAAU,CAAC,CAAC,WAAW,CAAC;QACtE,CAAC;QAED,QAAQ;YACN,MAAM,KAAK,GAAG,IAAI,CAAC,MAAM,CAAC,IAAI,CAAC,oBAAoB,CAAC,CAAC;YACrD,IAAI,CAAC,KAAK;gBAAE,OAAO,KAAK,CAAC;YACzB,OAAO,KAAK,CAAC,QAAQ,CAAC,IAAI,CAAC,CAAC,CAAS,EAAE,EAAE;gBACvC,IAAI,CAAC,CAAC,IAAI,KAAK,SAAS,CAAC,KAAK;oBAAE,OAAO,IAAI,CAAC;gBAC5C,IAAI,CAAC,CAAC,QAAQ;oBAAE,OAAO,CAAC,CAAC,QAAQ,CAAC,IAAI,CAAC,CAAC,CAAS,EAAE,EAAE,CAAC,CAAC,CAAC,IAAI,KAAK,SAAS,CAAC,KAAK,CAAC,CAAC;gBAClF,OAAO,KAAK,CAAC;YACf,CAAC,CAAC,CAAC;QACL,CAAC;QAED,WAAW;YACT,MAAM,KAAK,GAAG,IAAI,CAAC,MAAM,CAAC,IAAI,CAAC,oBAAoB,CAAC,CAAC;YACrD,IAAI,CAAC,KAAK;gBAAE,OAAO,KAAK,CAAC;YACzB,MAAM,aAAa,GAAG,KAAK,CAAC,WAAW,CAAC;YACxC,IAAI,CAAC,aAAa;gBAAE,OAAO,KAAK,CAAC;YACjC,OAAO,KAAK,CAAC,QAAQ,CAAC,IAAI,CAAC,CAAC,CAAS,EAAE,EAAE;gBACvC,IAAI,CAAC,CAAC,IAAI,KAAK,SAAS,CAAC,KAAK,IAAI,CAAC,CAAC,EAAE,KAAK,aAAa;oBAAE,OAAO,IAAI,CAAC;gBACtE,IAAI,CAAC,CAAC,QAAQ;oBAAE,OAAO,CAAC,CAAC,QAAQ,CAAC,IAAI,CAAC,CAAC,CAAS,EAAE,EAAE,CAAC,CAAC,CAAC,IAAI,KAAK,SAAS,CAAC,KAAK,IAAI,CAAC,CAAC,EAAE,KAAK,aAAa,CAAC,CAAC;gBAC5G,OAAO,KAAK,CAAC;YACf,CAAC,CAAC,CAAC;QACL,CAAC;KACF;IAED,OAAO,EAAE;QACP;;WAEG;QACH,KAAK,CAAC,iBAAiB;YACrB,MAAM,KAAK,GAAG,QAAQ,EAAE,CAAC;YACzB,IAAI,CAAC,aAAa,GAAG,YAAY,KAAK,EAAE,KAAK,EAAE,cAAc,IAAI,CAAC,EAAE,CAAC;YAErE,MAAM,MAAM,GAAG,MAAM,QAAQ,CAAC,GAAG,CAAC,uBAAuB,IAAI,CAAC,aAAa,EAAE,EAAE;gBAC7E,EAAE,EAAE,qBAAqB;aAC1B,CAAC,CAAC;YAEH,IAAI,CAAC,YAAY,GAAG,MAAM,CAAC,KAAK,CAAC;QACnC,CAAC;QAED,eAAe,CAAC,KAAsB;YACpC,OAAO,IAAI,CAAC,MAAM,CAAC,KAAK,CAAC,CAAC;QAC5B,CAAC;QAED;;WAEG;QACH,KAAK,CAAC,UAAU,CAAC,EAAU,EAAE,UAAoB,EAAE,OAAgB;YACjE,MAAM,QAAQ,GAAG,MAAM,QAAQ,CAAC,IAAI,CAAC,cAAc,EAAE,UAAU,IAAI,CAAC,aAAa,EAAE,EAAE;gBACnF,UAAU;gBACV,OAAO;aACR,CAAC,CAAC;YAEH,IAAI,QAAQ,EAAE,MAAM,KAAK,aAAa,EAAE;gBACtC,OAAO,IAAI,CAAC,UAAU,CAAC,EAAE,EAAE,UAAU,EAAE,QAAQ,CAAC,OAAO,CAAC,CAAC;aAC1D;YAED,OAAO,QAAQ,CAAC;QAClB,CAAC;QAED,eAAe,CAAC,YAA+B;YAC7C,MAAM,QAAQ,GAAG,CAAC,KAAK,CAAC,OAAO,CAAC,YAAY,CAAC,CAAC,CAAC,CAAC,YAAY,CAAC,CAAC,CAAC,CAAC,YAAY,CAAC,CAAC,CAAC;YAC/E,MAAM,WAAW,GAAG,cAAc,EAAE,CAAC;YACrC,MAAM,aAAa,GAAG,gBAAgB,EAAE,CAAC;YAEzC,MAAM,SAAS,GAAG,QAAQ,CAAC,CAAC,CAAC,CAAC,KAAK,CAAC,WAAW,CAAC,CAAC;YACjD,MAAM,aAAa,GAAG,IAAI,CAAC,oBAAoB,CAAC;YAEhD,IAAI,WAAW,CAAC,aAAa,EAAE;gBAC7B,IAAI,CAAC,aAAa,GAAG;oBACnB,GAAG,IAAI,CAAC,aAAa;oBACrB,GAAG,QAAQ;iBACZ,CAAC,MAAM,CAAC,CAAC,IAAI,EAAE,IAAI,EAAE,EAAE;oBACtB,yFAAyF;oBACzF,yFAAyF;oBACzF,MAAM,OAAO,GAAG,IAAI,CAAC,KAAK,CAAC,WAAW,CAAC,CAAC;oBACxC,IAAI,SAAS,CAAC,MAAM,KAAK,OAAO,CAAC,MAAM;wBAAE,OAAO,IAAI,CAAC;oBACrD,2CAA2C;oBAC3C,MAAM,UAAU,GAAG,QAAQ,CAAC,IAAI,CAAC,KAAK,CAAC,WAAW,CAAC,CAAC,CAAC,CAAC,EAAE,EAAE,CAAC,CAAC;oBAC5D,IAAI,IAAI,CAAC,oBAAoB,KAAK,SAAS,IAAI,UAAU,KAAK,IAAI,CAAC,oBAAoB;wBAAE,OAAO,IAAI,CAAC;oBACrG,IAAI,IAAI,CAAC,QAAQ,CAAC,IAAI,CAAC;wBAAE,OAAO,IAAI,CAAC;oBACrC,OAAO,CAAC,GAAG,IAAI,EAAE,IAAI,CAAC,CAAC;gBACzB,CAAC,EAAE,EAAE,CAAC,CAAC;aACR;iBAAM;gBACL,IAAI,CAAC,aAAa,GAAG,CAAC,GAAG,QAAQ,CAAC,CAAC;aACpC;YAED,aAAa,CAAC,oBAAoB,GAAG,KAAK,CAAC;YAE3C,MAAM,aAAa,GAAG,IAAI,CAAC,oBAAoB,CAAC;YAChD,IAAI,aAAa,KAAK,aAAa;gBAAE,WAAW,CAAC,MAAM,GAAG,EAAE,KAAK,EAAE,IAAI,CAAC,cAAc,EAAE,MAAM,EAAE,EAAE,EAAE,CAAC;YAErG,WAAW,CAAC,eAAe,GAAG,IAAI,CAAC;QACrC,CAAC;QAED,kBAAkB,CAAC,WAAmB;YACpC,MAAM,aAAa,GAAG,gBAAgB,EAAE,CAAC;YAEzC,MAAM,QAAQ,GAAG,IAAI,CAAC,aAAa,CAAC,MAAM,CAAC,CAAC,IAAI,EAAE,EAAE,CAAC,IAAI,KAAK,WAAW,CAAC,CAAC;YAC3E,IAAI,QAAQ,CAAC,MAAM,KAAK,CAAC;gBAAE,IAAI,CAAC,eAAe,CAAC,UAAU,IAAI,CAAC,oBAAoB,GAAG,CAAC,CAAC;;gBACnF,IAAI,CAAC,aAAa,GAAG,CAAC,GAAG,QAAQ,CAAC,CAAC;YAExC,aAAa,CAAC,oBAAoB,GAAG,KAAK,CAAC;QAC7C,CAAC;QAED;;WAEG;QACH,KAAK,CAAC,iBAAiB,CAAC,OAAgB;YACtC,MAAM,aAAa,GAAG,gBAAgB,EAAE,CAAC;YAEzC,MAAM,QAAQ,GAAG,MAAM,QAAQ,CAAC,IAAI,CAAC,cAAc,aAAa,CAAC,eAAe,CAAC,EAAE,WAAW,IAAI,CAAC,aAAa,EAAE,EAAE;gBAClH,OAAO;gBACT,gEAAgE;aAC/D,CAAC,CAAC,KAAK,CAAC,GAAG,EAAE,GAAE,CAAC,CAAC,CAAC;YACnB,IAAI,CAAC,QAAQ;gBAAE,OAAO,IAAI,CAAC;YAE3B,IAAI,QAAQ,EAAE,MAAM,KAAK,aAAa,EAAE;gBACtC,OAAO,IAAI,CAAC,iBAAiB,CAAC,QAAQ,CAAC,OAAO,CAAC,CAAC;aACjD;YAED,IAAI,CAAC,UAAU,GAAG,QAAQ,CAAC,GAAG,CAAC;YAC/B,OAAO,IAAI,CAAC,UAAU,CAAC;QACzB,CAAC;QAED;;WAEG;QACH,8DAA8D;QAC9D,UAAU,CAAC,IAAY,EAAE,KAAU;YACjC,MAAM,YAAY,GAAG,eAAe,EAAE,CAAC;YAEvC,IAAI,CAAC,WAAW,CAAC,IAAI,CAAC,EAAE,IAAI,EAAE,KAAK,EAAE,CAAC,CAAC;YAEvC,IAAI,SAAS;gBAAE,YAAY,CAAC,SAAS,CAAC,CAAC;YACvC,SAAS,GAAG,UAAU,CAAC,GAAG,EAAE;gBAC1B,YAAY,CAAC,OAAO,CAAC,sBAAsB,EAAE,IAAI,CAAC,WAAW,CAAC,CAAC;gBAC/D,IAAI,CAAC,WAAW,GAAG,EAAE,CAAC;YACxB,CAAC,EAAE,EAAE,CAAC,CAAC;QACT,CAAC;KACF;CACF,CAAC,CAAC;AAEH,eAAe,kBAAkB,CAAC",
      sourcesContent: ["import { defineStore } from 'pinia';\nimport { requests } from '@/common/plugins/axios';\nimport { Orientation } from '@/common/enums';\nimport { get, objectIsEmpty } from '@/common/utils';\nimport { PlayTypes } from '@/views/creatives/enums';\nimport { IPlaySettings, ILayer, ICreativeAudioSettings } from '@/views/creatives/interfaces';\nimport { useCreativeStore } from './creative';\nimport { useEditorStore } from './editor';\nimport { useHistoryStore } from './history';\n\nlet timeoutId: ReturnType<typeof setTimeout>;\n\nexport const getTotalLayers = (array = []) => array.reduce((prev, curr) => {\n  if (!curr.children) return prev;\n  return prev + getTotalLayers(curr.children);\n}, array.length);\n\nexport const usePlayCanvasStore = defineStore('playCanvas', {\n  state: () => ({\n    playPartners: [], // list of play partners that can be exported to\n    sizes: { // all assets used in creative file sizes for playable, along with config, engine and partner code\n      videos: [],\n      images: [],\n      fonts: [],\n      audio: [],\n      config: { size: 0 },\n      engine: { gameCode: 0, partnerCode: 0 },\n    },\n    previewURI: '', // used for createPreviewLink\n    muted: false, // boolean to mute playable\n    previewOrientation: Orientation.PORTRAIT, // enum for preview orientation\n    showPreview: false, // boolean to show the Preview / Path View\n    bulkUpdates: [], // array of updates to be  used in a bulk update after using the transform tool\n    btnEffectSettings: {}, // settings for the button effect\n    hugId: null,\n    oldSortablePath: null, // the previous sortable parent index where the node was dragged from (scene)\n    selectedPaths: [] as string[],\n    editorReadySetToFit: true,\n    exportVersion: '',\n    videoData: [],\n  }),\n\n  getters: {\n    scenes: () => {\n      const creativeStore = useCreativeStore();\n      return creativeStore.currentCreative.scenes ?? [];\n    },\n\n    settings: (): IPlaySettings => {\n      const creativeStore = useCreativeStore();\n      return creativeStore.currentCreative.settings || {} as IPlaySettings;\n    },\n\n    getCurrentSelectedPath: (state): string[] => {\n      if (!state.selectedPaths) return [];\n      return state.selectedPaths.sort((a, b) => {\n        for (let i = 0; i < a.length; i += 1) {\n          if (a[i] !== b[i]) return +a[i] - +b[i];\n        }\n        return 0;\n      });\n    },\n\n    getTotalLayers(): number {\n      if (this.getCurrentSceneIndex === undefined || !this.scenes[this.getCurrentSceneIndex] || this.scenes[this.getCurrentSceneIndex].length === 0) return 0;\n      return getTotalLayers(this.scenes[this.getCurrentSceneIndex].children);\n    },\n\n    getCurrentSceneIndex(): number {\n      if (!this.getCurrentSelectedPath || this.getCurrentSelectedPath.length === 0) return undefined;\n      return parseInt(this.getCurrentSelectedPath[0].match(/([0-9]+)/g)?.[0], 10);\n    },\n\n    getCurrentSelectionIndexes(): string[][] {\n      if (!this.getCurrentSelectedPath) return [];\n      return this.getCurrentSelectedPath.map((path) => path.match(/([0-9]+)/g));\n    },\n\n    getCurrentSelectedItems(): ILayer[] {\n      const creativeStore = useCreativeStore();\n      if (objectIsEmpty(creativeStore.currentCreative) || !this.getCurrentSelectedPath) return [{} as ILayer];\n      const items = get(creativeStore.currentCreative, this.getCurrentSelectedPath);\n      return Array.isArray(items) ? items : [items];\n    },\n\n    getOrientation(): Orientation {\n      return this.settings.orientation as Orientation || this.settings.orientationLock as Orientation || Orientation.PORTRAIT;\n    },\n\n    getOrientationLock(): Orientation {\n      return this.settings.orientationLock as Orientation || Orientation.PORTRAIT;\n    },\n\n    getUseBGAudio(): boolean {\n      return this.settings.useBGAudio as boolean || false;\n    },\n\n    getBGAudio(): ICreativeAudioSettings {\n      return this.settings.BGAudio as ICreativeAudioSettings || {} as ICreativeAudioSettings;\n    },\n\n    getPreviewOrientation(): Orientation {\n      return this.previewOrientation as Orientation;\n    },\n\n    getIsMuted(): boolean {\n      return this.muted;\n    },\n\n    getCurrentSceneLength(): number {\n      const sceneIndex = this.getCurrentSceneIndex;\n      const creativeStore = useCreativeStore();\n      if (!creativeStore.currentCreative.scenes || !creativeStore.currentCreative.scenes[sceneIndex]) return 0;\n      return creativeStore.currentCreative.scenes[sceneIndex].sceneLength;\n    },\n\n    hasVideo(): boolean {\n      const scene = this.scenes[this.getCurrentSceneIndex];\n      if (!scene) return false;\n      return scene.children.some((n: ILayer) => {\n        if (n.type === PlayTypes.VIDEO) return true;\n        if (n.children) return n.children.some((v: ILayer) => v.type === PlayTypes.VIDEO);\n        return false;\n      });\n    },\n\n    linkedLayer(): boolean {\n      const scene = this.scenes[this.getCurrentSceneIndex];\n      if (!scene) return false;\n      const linkedLayerId = scene.linkedLayer;\n      if (!linkedLayerId) return false;\n      return scene.children.some((n: ILayer) => {\n        if (n.type === PlayTypes.VIDEO && n.id === linkedLayerId) return true;\n        if (n.children) return n.children.some((v: ILayer) => v.type === PlayTypes.VIDEO && v.id === linkedLayerId);\n        return false;\n      });\n    },\n  },\n\n  actions: {\n    /**\n     * Fetch partner templates for play\n     */\n    async fetchPlayPartners() {\n      const route = useRoute();\n      this.exportVersion = `?version=${route?.query?.export_version || 2}`;\n\n      const result = await requests.get(`/types/partners/play${this.exportVersion}`, {\n        id: 'fetch-partners-play',\n      });\n\n      this.playPartners = result.items;\n    },\n\n    getSceneByIndex(index: number | string) {\n      return this.scenes[index];\n    },\n\n    /**\n     * Trigger creative export\n     */\n    async exportPlay(id: string, partnerIds: number[], session?: string) {\n      const response = await requests.post(`/creatives/${id}/export${this.exportVersion}`, {\n        partnerIds,\n        session,\n      });\n\n      if (response?.status === 'IN_PROGRESS') {\n        return this.exportPlay(id, partnerIds, response.session);\n      }\n\n      return response;\n    },\n\n    setSelectedPath(selectedPath: string | string[]): void {\n      const newPaths = (Array.isArray(selectedPath) ? selectedPath : [selectedPath]);\n      const editorStore = useEditorStore();\n      const creativeStore = useCreativeStore();\n\n      const newLength = newPaths[0].match(/([0-9]+)/g);\n      const oldSceneIndex = this.getCurrentSceneIndex;\n\n      if (editorStore.isMultiSelect) {\n        this.selectedPaths = [\n          ...this.selectedPaths,\n          ...newPaths,\n        ].reduce((prev, path) => {\n          // ignore select if the new select path is not the same length as the first selected path\n          // which means we can only select scene, layer and layers belong to the same object layer\n          const matches = path.match(/([0-9]+)/g);\n          if (newLength.length !== matches.length) return prev;\n          // ignore select that already been selected\n          const sceneIndex = parseInt(path.match(/([0-9]+)/g)[0], 10);\n          if (this.getCurrentSceneIndex !== undefined && sceneIndex !== this.getCurrentSceneIndex) return prev;\n          if (prev.includes(path)) return prev;\n          return [...prev, path];\n        }, []);\n      } else {\n        this.selectedPaths = [...newPaths];\n      }\n\n      creativeStore.showCreativeSettings = false;\n\n      const newSceneIndex = this.getCurrentSceneIndex;\n      if (newSceneIndex !== oldSceneIndex) editorStore.layers = { total: this.getTotalLayers, loaded: {} };\n\n      editorStore.showTransformer = true;\n    },\n\n    removeSelectedPath(removedPath: string): void {\n      const creativeStore = useCreativeStore();\n\n      const newPaths = this.selectedPaths.filter((path) => path !== removedPath);\n      if (newPaths.length === 0) this.setSelectedPath(`scenes[${this.getCurrentSceneIndex}]`);\n      else this.selectedPaths = [...newPaths];\n\n      creativeStore.showCreativeSettings = false;\n    },\n\n    /**\n     * Create a preview link\n     */\n    async createPreviewLink(session?: string) {\n      const creativeStore = useCreativeStore();\n\n      const response = await requests.post(`/creatives/${creativeStore.currentCreative.id}/preview${this.exportVersion}`, {\n        session,\n      // eslint-disable-next-line @typescript-eslint/no-empty-function\n      }).catch(() => {});\n      if (!response) return null;\n\n      if (response?.status === 'IN_PROGRESS') {\n        return this.createPreviewLink(response.session);\n      }\n\n      this.previewURI = response.src;\n      return this.previewURI;\n    },\n\n    /**\n     * Function to bulk update values after using the transform tool\n     */\n    // eslint-disable-next-line @typescript-eslint/no-explicit-any\n    bulkUpdate(path: string, value: any): void {\n      const historyStore = useHistoryStore();\n\n      this.bulkUpdates.push({ path, value });\n\n      if (timeoutId) clearTimeout(timeoutId);\n      timeoutId = setTimeout(() => {\n        historyStore.execute('updateCreativeByPath', this.bulkUpdates);\n        this.bulkUpdates = [];\n      }, 50);\n    },\n  },\n});\n\nexport default usePlayCanvasStore;\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8975594799e4f2ddd61c06fd55080cb48fa63fd4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_24jms4qfen = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_24jms4qfen();
import "core-js/modules/es.array.push.js";
import { defineStore } from 'pinia';
import { requests } from '@/common/plugins/axios';
import { Orientation } from '@/common/enums';
import { get, objectIsEmpty } from '@/common/utils';
import { PlayTypes } from '@/views/creatives/enums';
import { useCreativeStore } from './creative';
import { useEditorStore } from './editor';
import { useHistoryStore } from './history';
let timeoutId;
cov_24jms4qfen().s[0]++;
export const getTotalLayers = (array = (cov_24jms4qfen().b[0][0]++, [])) => {
  cov_24jms4qfen().f[0]++;
  cov_24jms4qfen().s[1]++;
  return array.reduce((prev, curr) => {
    cov_24jms4qfen().f[1]++;
    cov_24jms4qfen().s[2]++;
    if (!curr.children) {
      cov_24jms4qfen().b[1][0]++;
      cov_24jms4qfen().s[3]++;
      return prev;
    } else {
      cov_24jms4qfen().b[1][1]++;
    }
    cov_24jms4qfen().s[4]++;
    return prev + getTotalLayers(curr.children);
  }, array.length);
};
export const usePlayCanvasStore = (cov_24jms4qfen().s[5]++, defineStore('playCanvas', {
  state: () => {
    cov_24jms4qfen().f[2]++;
    cov_24jms4qfen().s[6]++;
    return {
      playPartners: [],
      sizes: {
        videos: [],
        images: [],
        fonts: [],
        audio: [],
        config: {
          size: 0
        },
        engine: {
          gameCode: 0,
          partnerCode: 0
        }
      },
      previewURI: '',
      muted: false,
      previewOrientation: Orientation.PORTRAIT,
      showPreview: false,
      bulkUpdates: [],
      btnEffectSettings: {},
      hugId: null,
      oldSortablePath: null,
      selectedPaths: [],
      editorReadySetToFit: true,
      exportVersion: '',
      videoData: []
    };
  },
  getters: {
    scenes: () => {
      cov_24jms4qfen().f[3]++;
      const creativeStore = (cov_24jms4qfen().s[7]++, useCreativeStore());
      cov_24jms4qfen().s[8]++;
      return (cov_24jms4qfen().b[2][0]++, creativeStore.currentCreative.scenes) ?? (cov_24jms4qfen().b[2][1]++, []);
    },
    settings: () => {
      cov_24jms4qfen().f[4]++;
      const creativeStore = (cov_24jms4qfen().s[9]++, useCreativeStore());
      cov_24jms4qfen().s[10]++;
      return (cov_24jms4qfen().b[3][0]++, creativeStore.currentCreative.settings) || (cov_24jms4qfen().b[3][1]++, {});
    },
    getCurrentSelectedPath: state => {
      cov_24jms4qfen().f[5]++;
      cov_24jms4qfen().s[11]++;
      if (!state.selectedPaths) {
        cov_24jms4qfen().b[4][0]++;
        cov_24jms4qfen().s[12]++;
        return [];
      } else {
        cov_24jms4qfen().b[4][1]++;
      }
      cov_24jms4qfen().s[13]++;
      return state.selectedPaths.sort((a, b) => {
        cov_24jms4qfen().f[6]++;
        cov_24jms4qfen().s[14]++;
        for (let i = (cov_24jms4qfen().s[15]++, 0); i < a.length; i += 1) {
          cov_24jms4qfen().s[16]++;
          if (a[i] !== b[i]) {
            cov_24jms4qfen().b[5][0]++;
            cov_24jms4qfen().s[17]++;
            return +a[i] - +b[i];
          } else {
            cov_24jms4qfen().b[5][1]++;
          }
        }
        cov_24jms4qfen().s[18]++;
        return 0;
      });
    },
    getTotalLayers() {
      cov_24jms4qfen().f[7]++;
      cov_24jms4qfen().s[19]++;
      if ((cov_24jms4qfen().b[7][0]++, this.getCurrentSceneIndex === undefined) || (cov_24jms4qfen().b[7][1]++, !this.scenes[this.getCurrentSceneIndex]) || (cov_24jms4qfen().b[7][2]++, this.scenes[this.getCurrentSceneIndex].length === 0)) {
        cov_24jms4qfen().b[6][0]++;
        cov_24jms4qfen().s[20]++;
        return 0;
      } else {
        cov_24jms4qfen().b[6][1]++;
      }
      cov_24jms4qfen().s[21]++;
      return getTotalLayers(this.scenes[this.getCurrentSceneIndex].children);
    },
    getCurrentSceneIndex() {
      cov_24jms4qfen().f[8]++;
      cov_24jms4qfen().s[22]++;
      if ((cov_24jms4qfen().b[9][0]++, !this.getCurrentSelectedPath) || (cov_24jms4qfen().b[9][1]++, this.getCurrentSelectedPath.length === 0)) {
        cov_24jms4qfen().b[8][0]++;
        cov_24jms4qfen().s[23]++;
        return undefined;
      } else {
        cov_24jms4qfen().b[8][1]++;
      }
      cov_24jms4qfen().s[24]++;
      return parseInt(this.getCurrentSelectedPath[0].match(/([0-9]+)/g)?.[0], 10);
    },
    getCurrentSelectionIndexes() {
      cov_24jms4qfen().f[9]++;
      cov_24jms4qfen().s[25]++;
      if (!this.getCurrentSelectedPath) {
        cov_24jms4qfen().b[10][0]++;
        cov_24jms4qfen().s[26]++;
        return [];
      } else {
        cov_24jms4qfen().b[10][1]++;
      }
      cov_24jms4qfen().s[27]++;
      return this.getCurrentSelectedPath.map(path => {
        cov_24jms4qfen().f[10]++;
        cov_24jms4qfen().s[28]++;
        return path.match(/([0-9]+)/g);
      });
    },
    getCurrentSelectedItems() {
      cov_24jms4qfen().f[11]++;
      const creativeStore = (cov_24jms4qfen().s[29]++, useCreativeStore());
      cov_24jms4qfen().s[30]++;
      if ((cov_24jms4qfen().b[12][0]++, objectIsEmpty(creativeStore.currentCreative)) || (cov_24jms4qfen().b[12][1]++, !this.getCurrentSelectedPath)) {
        cov_24jms4qfen().b[11][0]++;
        cov_24jms4qfen().s[31]++;
        return [{}];
      } else {
        cov_24jms4qfen().b[11][1]++;
      }
      const items = (cov_24jms4qfen().s[32]++, get(creativeStore.currentCreative, this.getCurrentSelectedPath));
      cov_24jms4qfen().s[33]++;
      return Array.isArray(items) ? (cov_24jms4qfen().b[13][0]++, items) : (cov_24jms4qfen().b[13][1]++, [items]);
    },
    getOrientation() {
      cov_24jms4qfen().f[12]++;
      cov_24jms4qfen().s[34]++;
      return (cov_24jms4qfen().b[14][0]++, this.settings.orientation) || (cov_24jms4qfen().b[14][1]++, this.settings.orientationLock) || (cov_24jms4qfen().b[14][2]++, Orientation.PORTRAIT);
    },
    getOrientationLock() {
      cov_24jms4qfen().f[13]++;
      cov_24jms4qfen().s[35]++;
      return (cov_24jms4qfen().b[15][0]++, this.settings.orientationLock) || (cov_24jms4qfen().b[15][1]++, Orientation.PORTRAIT);
    },
    getUseBGAudio() {
      cov_24jms4qfen().f[14]++;
      cov_24jms4qfen().s[36]++;
      return (cov_24jms4qfen().b[16][0]++, this.settings.useBGAudio) || (cov_24jms4qfen().b[16][1]++, false);
    },
    getBGAudio() {
      cov_24jms4qfen().f[15]++;
      cov_24jms4qfen().s[37]++;
      return (cov_24jms4qfen().b[17][0]++, this.settings.BGAudio) || (cov_24jms4qfen().b[17][1]++, {});
    },
    getPreviewOrientation() {
      cov_24jms4qfen().f[16]++;
      cov_24jms4qfen().s[38]++;
      return this.previewOrientation;
    },
    getIsMuted() {
      cov_24jms4qfen().f[17]++;
      cov_24jms4qfen().s[39]++;
      return this.muted;
    },
    getCurrentSceneLength() {
      cov_24jms4qfen().f[18]++;
      const sceneIndex = (cov_24jms4qfen().s[40]++, this.getCurrentSceneIndex);
      const creativeStore = (cov_24jms4qfen().s[41]++, useCreativeStore());
      cov_24jms4qfen().s[42]++;
      if ((cov_24jms4qfen().b[19][0]++, !creativeStore.currentCreative.scenes) || (cov_24jms4qfen().b[19][1]++, !creativeStore.currentCreative.scenes[sceneIndex])) {
        cov_24jms4qfen().b[18][0]++;
        cov_24jms4qfen().s[43]++;
        return 0;
      } else {
        cov_24jms4qfen().b[18][1]++;
      }
      cov_24jms4qfen().s[44]++;
      return creativeStore.currentCreative.scenes[sceneIndex].sceneLength;
    },
    hasVideo() {
      cov_24jms4qfen().f[19]++;
      const scene = (cov_24jms4qfen().s[45]++, this.scenes[this.getCurrentSceneIndex]);
      cov_24jms4qfen().s[46]++;
      if (!scene) {
        cov_24jms4qfen().b[20][0]++;
        cov_24jms4qfen().s[47]++;
        return false;
      } else {
        cov_24jms4qfen().b[20][1]++;
      }
      cov_24jms4qfen().s[48]++;
      return scene.children.some(n => {
        cov_24jms4qfen().f[20]++;
        cov_24jms4qfen().s[49]++;
        if (n.type === PlayTypes.VIDEO) {
          cov_24jms4qfen().b[21][0]++;
          cov_24jms4qfen().s[50]++;
          return true;
        } else {
          cov_24jms4qfen().b[21][1]++;
        }
        cov_24jms4qfen().s[51]++;
        if (n.children) {
          cov_24jms4qfen().b[22][0]++;
          cov_24jms4qfen().s[52]++;
          return n.children.some(v => {
            cov_24jms4qfen().f[21]++;
            cov_24jms4qfen().s[53]++;
            return v.type === PlayTypes.VIDEO;
          });
        } else {
          cov_24jms4qfen().b[22][1]++;
        }
        cov_24jms4qfen().s[54]++;
        return false;
      });
    },
    linkedLayer() {
      cov_24jms4qfen().f[22]++;
      const scene = (cov_24jms4qfen().s[55]++, this.scenes[this.getCurrentSceneIndex]);
      cov_24jms4qfen().s[56]++;
      if (!scene) {
        cov_24jms4qfen().b[23][0]++;
        cov_24jms4qfen().s[57]++;
        return false;
      } else {
        cov_24jms4qfen().b[23][1]++;
      }
      const linkedLayerId = (cov_24jms4qfen().s[58]++, scene.linkedLayer);
      cov_24jms4qfen().s[59]++;
      if (!linkedLayerId) {
        cov_24jms4qfen().b[24][0]++;
        cov_24jms4qfen().s[60]++;
        return false;
      } else {
        cov_24jms4qfen().b[24][1]++;
      }
      cov_24jms4qfen().s[61]++;
      return scene.children.some(n => {
        cov_24jms4qfen().f[23]++;
        cov_24jms4qfen().s[62]++;
        if ((cov_24jms4qfen().b[26][0]++, n.type === PlayTypes.VIDEO) && (cov_24jms4qfen().b[26][1]++, n.id === linkedLayerId)) {
          cov_24jms4qfen().b[25][0]++;
          cov_24jms4qfen().s[63]++;
          return true;
        } else {
          cov_24jms4qfen().b[25][1]++;
        }
        cov_24jms4qfen().s[64]++;
        if (n.children) {
          cov_24jms4qfen().b[27][0]++;
          cov_24jms4qfen().s[65]++;
          return n.children.some(v => {
            cov_24jms4qfen().f[24]++;
            cov_24jms4qfen().s[66]++;
            return (cov_24jms4qfen().b[28][0]++, v.type === PlayTypes.VIDEO) && (cov_24jms4qfen().b[28][1]++, v.id === linkedLayerId);
          });
        } else {
          cov_24jms4qfen().b[27][1]++;
        }
        cov_24jms4qfen().s[67]++;
        return false;
      });
    }
  },
  actions: {
    /**
     * Fetch partner templates for play
     */
    async fetchPlayPartners() {
      cov_24jms4qfen().f[25]++;
      const route = (cov_24jms4qfen().s[68]++, useRoute());
      cov_24jms4qfen().s[69]++;
      this.exportVersion = `?version=${(cov_24jms4qfen().b[29][0]++, route?.query?.export_version) || (cov_24jms4qfen().b[29][1]++, 2)}`;
      const result = (cov_24jms4qfen().s[70]++, await requests.get(`/types/partners/play${this.exportVersion}`, {
        id: 'fetch-partners-play'
      }));
      cov_24jms4qfen().s[71]++;
      this.playPartners = result.items;
    },
    getSceneByIndex(index) {
      cov_24jms4qfen().f[26]++;
      cov_24jms4qfen().s[72]++;
      return this.scenes[index];
    },
    /**
     * Trigger creative export
     */
    async exportPlay(id, partnerIds, session) {
      cov_24jms4qfen().f[27]++;
      const response = (cov_24jms4qfen().s[73]++, await requests.post(`/creatives/${id}/export${this.exportVersion}`, {
        partnerIds,
        session
      }));
      cov_24jms4qfen().s[74]++;
      if (response?.status === 'IN_PROGRESS') {
        cov_24jms4qfen().b[30][0]++;
        cov_24jms4qfen().s[75]++;
        return this.exportPlay(id, partnerIds, response.session);
      } else {
        cov_24jms4qfen().b[30][1]++;
      }
      cov_24jms4qfen().s[76]++;
      return response;
    },
    setSelectedPath(selectedPath) {
      cov_24jms4qfen().f[28]++;
      const newPaths = (cov_24jms4qfen().s[77]++, Array.isArray(selectedPath) ? (cov_24jms4qfen().b[31][0]++, selectedPath) : (cov_24jms4qfen().b[31][1]++, [selectedPath]));
      const editorStore = (cov_24jms4qfen().s[78]++, useEditorStore());
      const creativeStore = (cov_24jms4qfen().s[79]++, useCreativeStore());
      const newLength = (cov_24jms4qfen().s[80]++, newPaths[0].match(/([0-9]+)/g));
      const oldSceneIndex = (cov_24jms4qfen().s[81]++, this.getCurrentSceneIndex);
      cov_24jms4qfen().s[82]++;
      if (editorStore.isMultiSelect) {
        cov_24jms4qfen().b[32][0]++;
        cov_24jms4qfen().s[83]++;
        this.selectedPaths = [...this.selectedPaths, ...newPaths].reduce((prev, path) => {
          cov_24jms4qfen().f[29]++;
          // ignore select if the new select path is not the same length as the first selected path
          // which means we can only select scene, layer and layers belong to the same object layer
          const matches = (cov_24jms4qfen().s[84]++, path.match(/([0-9]+)/g));
          cov_24jms4qfen().s[85]++;
          if (newLength.length !== matches.length) {
            cov_24jms4qfen().b[33][0]++;
            cov_24jms4qfen().s[86]++;
            return prev;
          } else {
            cov_24jms4qfen().b[33][1]++;
          }
          // ignore select that already been selected
          const sceneIndex = (cov_24jms4qfen().s[87]++, parseInt(path.match(/([0-9]+)/g)[0], 10));
          cov_24jms4qfen().s[88]++;
          if ((cov_24jms4qfen().b[35][0]++, this.getCurrentSceneIndex !== undefined) && (cov_24jms4qfen().b[35][1]++, sceneIndex !== this.getCurrentSceneIndex)) {
            cov_24jms4qfen().b[34][0]++;
            cov_24jms4qfen().s[89]++;
            return prev;
          } else {
            cov_24jms4qfen().b[34][1]++;
          }
          cov_24jms4qfen().s[90]++;
          if (prev.includes(path)) {
            cov_24jms4qfen().b[36][0]++;
            cov_24jms4qfen().s[91]++;
            return prev;
          } else {
            cov_24jms4qfen().b[36][1]++;
          }
          cov_24jms4qfen().s[92]++;
          return [...prev, path];
        }, []);
      } else {
        cov_24jms4qfen().b[32][1]++;
        cov_24jms4qfen().s[93]++;
        this.selectedPaths = [...newPaths];
      }
      cov_24jms4qfen().s[94]++;
      creativeStore.showCreativeSettings = false;
      const newSceneIndex = (cov_24jms4qfen().s[95]++, this.getCurrentSceneIndex);
      cov_24jms4qfen().s[96]++;
      if (newSceneIndex !== oldSceneIndex) {
        cov_24jms4qfen().b[37][0]++;
        cov_24jms4qfen().s[97]++;
        editorStore.layers = {
          total: this.getTotalLayers,
          loaded: {}
        };
      } else {
        cov_24jms4qfen().b[37][1]++;
      }
      cov_24jms4qfen().s[98]++;
      editorStore.showTransformer = true;
    },
    removeSelectedPath(removedPath) {
      cov_24jms4qfen().f[30]++;
      const creativeStore = (cov_24jms4qfen().s[99]++, useCreativeStore());
      const newPaths = (cov_24jms4qfen().s[100]++, this.selectedPaths.filter(path => {
        cov_24jms4qfen().f[31]++;
        cov_24jms4qfen().s[101]++;
        return path !== removedPath;
      }));
      cov_24jms4qfen().s[102]++;
      if (newPaths.length === 0) {
        cov_24jms4qfen().b[38][0]++;
        cov_24jms4qfen().s[103]++;
        this.setSelectedPath(`scenes[${this.getCurrentSceneIndex}]`);
      } else {
        cov_24jms4qfen().b[38][1]++;
        cov_24jms4qfen().s[104]++;
        this.selectedPaths = [...newPaths];
      }
      cov_24jms4qfen().s[105]++;
      creativeStore.showCreativeSettings = false;
    },
    /**
     * Create a preview link
     */
    async createPreviewLink(session) {
      cov_24jms4qfen().f[32]++;
      const creativeStore = (cov_24jms4qfen().s[106]++, useCreativeStore());
      const response = (cov_24jms4qfen().s[107]++, await requests.post(`/creatives/${creativeStore.currentCreative.id}/preview${this.exportVersion}`, {
        session
        // eslint-disable-next-line @typescript-eslint/no-empty-function
      }).catch(() => {
        cov_24jms4qfen().f[33]++;
      }));
      cov_24jms4qfen().s[108]++;
      if (!response) {
        cov_24jms4qfen().b[39][0]++;
        cov_24jms4qfen().s[109]++;
        return null;
      } else {
        cov_24jms4qfen().b[39][1]++;
      }
      cov_24jms4qfen().s[110]++;
      if (response?.status === 'IN_PROGRESS') {
        cov_24jms4qfen().b[40][0]++;
        cov_24jms4qfen().s[111]++;
        return this.createPreviewLink(response.session);
      } else {
        cov_24jms4qfen().b[40][1]++;
      }
      cov_24jms4qfen().s[112]++;
      this.previewURI = response.src;
      cov_24jms4qfen().s[113]++;
      return this.previewURI;
    },
    /**
     * Function to bulk update values after using the transform tool
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    bulkUpdate(path, value) {
      cov_24jms4qfen().f[34]++;
      const historyStore = (cov_24jms4qfen().s[114]++, useHistoryStore());
      cov_24jms4qfen().s[115]++;
      this.bulkUpdates.push({
        path,
        value
      });
      cov_24jms4qfen().s[116]++;
      if (timeoutId) {
        cov_24jms4qfen().b[41][0]++;
        cov_24jms4qfen().s[117]++;
        clearTimeout(timeoutId);
      } else {
        cov_24jms4qfen().b[41][1]++;
      }
      cov_24jms4qfen().s[118]++;
      timeoutId = setTimeout(() => {
        cov_24jms4qfen().f[35]++;
        cov_24jms4qfen().s[119]++;
        historyStore.execute('updateCreativeByPath', this.bulkUpdates);
        cov_24jms4qfen().s[120]++;
        this.bulkUpdates = [];
      }, 50);
    }
  }
}));
export default usePlayCanvasStore;